// src/components/Sidebar.js
import React, { useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
} from "@mui/material";
import {
  Dashboard,
  People,
  MonetizationOn,
  Menu,
} from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import ListIcon from "@mui/icons-material/List";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import BackupIcon from "@mui/icons-material/Backup";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp } from "@fortawesome/free-solid-svg-icons";
import { logger } from "../utils/logger";

const Sidebar = ({ onMenuSelect, user }) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(true);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const menuItems = [
    {
      label: "Dashboard",
      icon: <Dashboard />,
      action: "dashboard",
      roles: ["admin1", "admin2", "superadmin", "editor1", "editor2"],
    },
    {
      label: "Donors",
      icon: <People />,
      action: "donors",
      roles: ["superadmin", "admin1", "admin2", "editor1", "editor2"],
    },
    {
      label: "Donations",
      icon: <MonetizationOn />,
      action: "donations",
      roles: ["superadmin", "admin1", "admin2", "editor2"],
    },
    {
      label: "NPF & UAF Details",
      icon: <MonetizationOn />,
      action: "paypurpose-details",
      roles: ["superadmin", "admin1", "admin2"],
    },
    {
      label: "Import Data",
      icon: <FontAwesomeIcon icon={faCloudArrowUp} />,
      action: "import",
      roles: ["superadmin", "admin1", "admin2"],
    },
    {
      label: "Reports",
      icon: <DriveFolderUploadIcon />,
      action: "reports",
      roles: ["superadmin", "admin1", "admin2"],
    },
    {
      label: "Reset Prasad",
      icon: <RestartAltIcon />,
      action: "reset-prasad",
      roles: ["superadmin", "admin2"],
    },
    {
      label: "Users",
      icon: <People />,
      action: "user-list",
      roles: ["superadmin", "admin1", "admin2"],
    },
    {
      label: "Manage Options",
      icon: <ListIcon />,
      action: "manage-options",
      roles: ["superadmin", "admin1", "admin2"],
    },
    {
      label: "Data Export",
      icon: <BackupIcon />,
      action: "data-export",
      roles: ["superadmin", "admin1", "admin2"],
    },
    // {
    //   label: "Activity Logs",
    //   icon: <ManageSearchIcon />,
    //   action: "user-logs",
    //   roles: ["superadmin", "admin1", "admin2"],
    // },
  ];

  return (
    <Box
      sx={{
        width: isOpen ? 250 : 70,
        minWidth: isOpen ? 250 : 70,
        maxWidth: isOpen ? 250 : 70,
        backgroundColor: theme.palette.primary.main,
        color: "white",
        transition: "width 0.3s, min-width 0.3s, max-width 0.3s",
        position: "relative",
        flexShrink: 0,
      }}
    >
      {/* Toggle Button */}
      <IconButton
        onClick={handleToggle}
        sx={{ color: "white", margin: "10px" }}
        data-log="SideMenu Toggle Icon Button"
      >
        <Menu />
        {isOpen && user && (
          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                color: "#fff",
                padding: "10px 20px",
              }}
            >
              {/* Welcome, {user.username} */}
              Menu
            </Typography>

            {/* <Typography
              variant="subtitle1"
              sx={{
                color: "#fff",
              }}
            >
              {user.role}
            </Typography> */}
          </Box>
        )}
      </IconButton>

      <List>
        {menuItems
          .filter((item) => item.roles.includes(user.role)) // Filter based on role
          .map((item) => (
            <ListItem
              button={String(true)}
              key={item.label}
              onClick={() => {
                onMenuSelect(item.action);
                logger.info(`Navigated to: ${item.label}`, {
                  page: item.label,
                  action: item.action,
                  username: user.username,
                  role: user.role,
                });
              }}
            >
              <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
              {isOpen && <ListItemText primary={item.label} />}
            </ListItem>
          ))}
      </List>
    </Box>
  );
};

export default Sidebar;
